module.exports = __webpack_public_path__ + "static/xceltoken (2)-663da343fab5b5bdeceed7c4c875c4a7.png";